import { aiColors } from '@euler/app/flows/ai-suite/theme';
import {
  BiDatasetAccess,
  BiDatasetVisibility,
  BiUploadedDatasetView,
} from '@euler/model/bi/dataset';
import { Database, Lock, Users } from 'lucide-react-native';
import { memo } from 'react';
import { BiTag } from '../../components/ui/BiTag';
import {
  biDatasetSourceText,
  biDatasetUsageText,
  kBiDatasetVisibilityTags,
} from '../functions/biLibraryText';
import { LibraryTile } from './LibraryTile';

/** An uploaded dataset: what it is, where it came from, where it is used. */
export const DatasetTile = memo(
  ({
    dataset,
    onOpen,
  }: {
    dataset: BiUploadedDatasetView;
    onOpen: () => void;
  }) => {
    const store = dataset.visibility === BiDatasetVisibility.Store;
    return (
      <LibraryTile
        icon={Database}
        color={aiColors.amber}
        name={dataset.name}
        accessibilityLabel={`打开数据 ${dataset.name}`}
        onPress={onOpen}
        tags={
          <>
            <BiTag
              text={kBiDatasetVisibilityTags[dataset.visibility]}
              color={store ? aiColors.green : aiColors.mutedForeground}
              icon={store ? Users : Lock}
            />
            {dataset.permission === BiDatasetAccess.Manage ? null : (
              <BiTag text="只能使用" color={aiColors.violet} />
            )}
          </>
        }
        lines={[
          dataset.description,
          biDatasetSourceText(dataset),
          biDatasetUsageText(dataset),
        ]}
      />
    );
  },
);
